import BaseRoute from "../../../lib/itn-ui-kit/route/base-route";
import { service } from "../../../lib/itn-ui-kit/services/service-container";

import Template from "./template";

export default class LandingRoute extends BaseRoute {
  @service landingService;

  element = (<Template />);

  async loader() {
    return {};
  }
}
